import React, { useState } from "react";
import "./style.css";
import { Button } from "../ui/button";
import Navigation from "../Navigation";
// import Footer from "../Footer";
import { Link } from "react-router-dom";

// images
import img3D1 from "../../assets/images/portfolio/Breath-Control1.webp";
import imgGD1 from "../../assets/images/MIG-Logo.webp";
import imgPhoto1 from "../../assets/images/portfolio/photography/img7.webp";
import imgVFX1 from "../../assets/images/portfolio/Gemini.webp"

// const images = [img3D1, imgGD1, imgPhoto1, imgVFX1];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState("all");

  const categories = [
    { id: "all", label: "All Work" },
    { id: "3d", label: "3D Design" },
    { id: "graphics", label: "Graphic Design" },
    { id: "photography", label: "Photography" },
    { id: "visuals", label: "Visual Effects" },
  ];

  const portfolioItems = [
    {
      id: 1,
      title: "3D",
      category: "3d",
      image: img3D1,
      path: "3d-work"
    },
    {
      id: 2,
      title: "Graphic Design",
      category: "graphics",
      image: imgGD1,
      path: "graphic-design"
    },
    {
      id: 3,
      title: "Photography",
      category: "photography",
      image: imgPhoto1,
      path: "photography"
    },
    {
      id: 4,
      title: "Visuals",
      category: "visuals",
      image: imgVFX1,
      path: "visual-effects"
    },
    // {
    //   id: 5,
    //   title: "Architectural Visualization",
    //   category: "3d",
    //   image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=500&h=600&fit=crop"
    // },
    // {
    //   id: 6,
    //   title: "Product Design Package",
    //   category: "graphics",
    //   image: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=500&h=600&fit=crop"
    // },
  ];

  const filteredItems = activeCategory === "all" 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <div>
    <section id="portfolio" className="portfolio-section">
      <Navigation />

      <div className="portfolio-container">
        {/* Header */}
        <div className="portfolio-header">
          <h2>Our Work</h2>
          <p>
            Explore our diverse portfolio of cutting-edge designs and creative solutions
          </p>
        </div>

        {/* Category Filter */}
        <div className="portfolio-filters">
          {categories.map((category) => (
            <Button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`filter-btn ${
                activeCategory === category.id
                  ? "filter-btn.active"
                  : "bg-card text-card-foreground hover:bg-accent/20"
              }`}
            >
              {category.label}
            </Button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="portfolio-grid">
          {filteredItems.map((item, index) => (
            <Link key={item.id} to={`/portfolio/${item.path}`} className="portfolio-item" style={{ animationDelay: `${index * 100}ms` }}>
              <img src={item.image} alt={item.title} className="w-full h-80 object-cover" />
              <div className="portfolio-overlay">
                <div className="portfolio-info">
                  <h3>{item.title}</h3>
                  <span>
                    {categories.find(cat => cat.id === item.category)?.label}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      {/* <Button style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>View More</Button> */}
      <br />
      
    </section>
    {/* <Footer /> */}
    </div>
  );
};

export default Portfolio;